[
  {
    "id": "box-truck-roll-up-door-repair",
    "path": "/Box-Truck-Roll-Up-Door-Repair-Near-Me",
    "kind": "service",
    "navLabel": "Box Truck Roll-Up Doors",
    "eyebrow": "Box truck rear doors",
    "title": "Box Truck Roll-Up Door Repair in Brighton | Motor City Truck Collision",
    "description": "Box truck roll-up door repair in Brighton for damaged curtains, tracks, rollers, seals and rear frames. Share photos and request an assessment.",
    "h1": "Box Truck Roll-Up Door Repair in Brighton",
    "intro": "Motor City Truck Collision repairs and replaces commercial box truck roll-up doors in Brighton. We assess the door and the rear structure together, including damage from loading docks that affects how the door travels, closes or seals.",
    "answer": {
      "question": "What can be repaired on a box truck roll-up door?",
      "text": "The work can include damaged curtain panels, tracks, rollers, bottom seals and the rear frame supporting the door. A door that sticks after a dock hit may need attention to the surrounding body as well as its moving parts. Photos of both tracks, the curtain and rear sill help define the assessment."
    },
    "sections": [
      {
        "heading": "Look beyond the damaged door panel",
        "paragraphs": [
          "A bent curtain is one possible problem. Tracks can move, rollers can wear, and a distorted rear opening can prevent the door from closing evenly. Explain whether the problem began after an impact or developed gradually."
        ],
        "bullets": [
          "Torn or bent curtain panels",
          "Jumped tracks or damaged rollers",
          "Poor sealing along the bottom edge",
          "Rear frame or sill damage"
        ]
      },
      {
        "heading": "Identify the door and the surrounding body",
        "paragraphs": [
          "Include the door manufacturer or any visible markings if available. Whiting, Todco and comparable commercial doors may require different components. Also mention whether the door is insulated.",
          "If the liftgate pocket or rear sill was damaged at the same time, include that area in the request. The door repair can then be assessed alongside the related bodywork."
        ]
      }
    ],
    "checklist": {
      "heading": "Photos and details for your door assessment",
      "items": [
        "Vehicle type and door brand, if known",
        "The full rear opening and the door curtain",
        "Both tracks, rollers and the bottom seal",
        "Any impact damage around the sill or liftgate"
      ]
    },
    "faqs": [
      {
        "question": "Can a door that jumps its track be repaired?",
        "answer": "Describe when it jumps and show both tracks. The assessment needs to distinguish worn or damaged door components from movement in the rear body opening."
      },
      {
        "question": "Do you work on insulated roll-up doors?",
        "answer": "We assess insulated commercial rear doors. Identify the door and its construction so the shop can discuss suitable repair or replacement components."
      },
      {
        "question": "Should I include rear body damage in the same request?",
        "answer": "Yes. Send photos of the rear frame, sill and adjoining liftgate bodywork so the full damage can be reviewed together."
      }
    ],
    "related": [
      {
        "path": "/box-truck-repair.html",
        "label": "Box truck body repair"
      },
      {
        "path": "/Lift-Gate-Repair",
        "label": "Liftgate body repairs"
      },
      {
        "path": "/Fleet-Truck-Body-Repair",
        "label": "Fleet body repair"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/Box-Truck-Roll-Up-Door-Repair-Near-Me"
    ],
    "preservedFacts": [
      "Commercial roll-up door curtains, tracks, rollers, seals and rear frames.",
      "Door brands such as Whiting and Todco are examples, without dealer authorization claims.",
      "Insulated, swing and side-door work is discussed in the source.",
      "Related liftgate pocket and rear sill damage should be assessed."
    ]
  },
  {
    "id": "box-truck-roof-repair-cost",
    "path": "/Box-Truck-Roof-Repair-Cost",
    "kind": "service",
    "navLabel": "Box Truck Roof Repair Cost",
    "eyebrow": "Roof repair assessment",
    "title": "Box Truck Roof Repair Cost and Quote Factors | Motor City Truck Collision",
    "description": "Understand the damage and quote factors behind box truck roof repair. Motor City Truck Collision in Brighton assesses leaks, torn panels and adjoining damage.",
    "h1": "What Affects Box Truck Roof Repair Cost?",
    "intro": "Box truck roof repair costs depend on the opening, the surrounding structure and how far water has traveled. Motor City Truck Collision in Brighton reviews the damage before discussing whether the work involves a local repair, replacement panels or a larger body repair.",
    "answer": {
      "question": "How much does box truck roof repair cost?",
      "text": "There is no single price that covers every roof problem. A seam repair differs from a long tear, damaged roof panel or leak that has affected the interior and floor. Send a wide roof photo and close-ups of the opening so the shop can discuss the repair scope before quoting."
    },
    "sections": [
      {
        "heading": "The visible leak is only part of the scope",
        "paragraphs": [
          "Water can enter at a roof seam and appear somewhere else inside the box. The assessment should include the front wall, rear header and interior areas beneath the roof, rather than treating the drip location as the whole problem."
        ],
        "bullets": [
          "Size and location of the opening",
          "Condition of the adjoining roof panel and joints",
          "Moisture affecting interior materials",
          "Damage extending into the wall or floor"
        ]
      },
      {
        "heading": "A sealant repair and a roof panel repair are different jobs",
        "paragraphs": [
          "Sealant may be part of a small seam repair when the supporting material is suitable. It does not replace missing metal or repair a torn panel by itself.",
          "A quote should describe the identified damage and the proposed work. If an opening, wet material or adjoining damage needs closer inspection, discuss that with the shop before comparing prices."
        ]
      }
    ],
    "checklist": {
      "heading": "What to include with a roof quote request",
      "items": [
        "Truck and cargo-body type",
        "A wide view of the roof and close-ups of the opening",
        "Photos of staining or damage inside the box",
        "When the leak appears and any known impact",
        "Your preferred return date"
      ]
    },
    "faqs": [
      {
        "question": "Can you quote from the truck model alone?",
        "answer": "The model identifies the vehicle, but it does not show the roof damage. Cargo-body details and optional photos help describe the damage."
      },
      {
        "question": "Does every leaking roof need replacement?",
        "answer": "No single repair fits every leak. The opening, panel condition and adjoining damage help determine whether a local repair or replacement work should be considered."
      },
      {
        "question": "Why should I photograph the inside as well?",
        "answer": "Interior photos can show where water has traveled and whether the repair assessment needs to include lining, walls or flooring."
      }
    ],
    "related": [
      {
        "path": "/box-truck-roof-leak-body-repair",
        "label": "Box truck roof leak repair"
      },
      {
        "path": "/box-truck-repair.html",
        "label": "Box truck body repair"
      },
      {
        "path": "/Box-Truck-Wall-Repair-Near-Me",
        "label": "Box truck wall repair"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/Box-Truck-Roof-Repair-Cost"
    ],
    "preservedFacts": [
      "Cost varies by seam/patch versus panel work and moisture damage.",
      "Photos of the wide roof and opening begin the assessment.",
      "Sealant is not a substitute for repairing torn roof skin.",
      "Front wall, rear header and floor may need review."
    ]
  },
  {
    "id": "box-truck-wall-repair",
    "path": "/Box-Truck-Wall-Repair-Near-Me",
    "kind": "service",
    "navLabel": "Box Truck Wall Repair",
    "eyebrow": "Cargo-body sidewalls",
    "title": "Box Truck Wall Repair in Brighton, MI | Motor City Truck Collision",
    "description": "Box truck wall repair for punctures, damaged panels, separation and corrosion. Request a body assessment at Motor City Truck Collision in Brighton.",
    "h1": "Box Truck Wall Repair and Panel Replacement",
    "intro": "Motor City Truck Collision repairs box truck walls damaged by impacts, wear and water intrusion. At our Brighton shop, the assessment considers the outer panel and what supports it, including the frame, interior lining and insulation where present.",
    "answer": {
      "question": "Can a damaged box truck wall be repaired?",
      "text": "Repair options depend on the panel material, size of the damaged area and condition of the structure behind it. A small opening and a wall with damaged framing require different work. Share exterior and interior photos so the shop can discuss local repair, panel replacement or a broader body repair."
    },
    "sections": [
      {
        "heading": "Understand which parts of the wall are affected",
        "paragraphs": [
          "A cargo-body wall may use aluminum or reinforced panels over a supporting frame, with interior lining and sometimes insulation. Damage can extend through more than the outer skin."
        ],
        "bullets": [
          "Punctures or torn outer panels",
          "Separation between wall layers",
          "Corrosion around panels and joints",
          "Damaged framing or interior lining"
        ]
      },
      {
        "heading": "Repair the opening and its adjoining joints",
        "paragraphs": [
          "The condition of the nearby panels and frame matters when choosing between a local repair and replacement work. Include any damage at corners, doors or the roof edge, even if the main impact is in the sidewall.",
          "Sealing and refinishing are part of the body-repair discussion. Tell the shop whether the wall carries graphics or fleet colors, and whether water has reached the cargo area."
        ]
      }
    ],
    "checklist": {
      "heading": "Useful information for a wall repair request",
      "items": [
        "Truck and cargo-body type",
        "A wide photo of the full affected wall",
        "Close-ups of the opening and adjoining joints",
        "Interior photos of lining, framing or staining",
        "Any graphics or paint colors that need attention"
      ]
    },
    "faqs": [
      {
        "question": "Can you replace a damaged wall panel?",
        "answer": "We assess damaged wall panels for repair or replacement. The assessment considers the damaged section, its supporting frame and how it joins the remaining body."
      },
      {
        "question": "What if the wall layers are separating?",
        "answer": "Show where separation appears on both sides if possible. Water intrusion and the condition of the layers behind the visible panel are relevant to the repair scope."
      },
      {
        "question": "Should roof or corner damage be included?",
        "answer": "Yes. A wall impact can affect adjoining joints and corners. Include those areas so the assessment covers the connected body damage."
      }
    ],
    "image": {
      "src": "https://www.motorcitytruckcollision.com/uploaded/images/Collision/Box-Truck-Repair/box-truck-repairs-418.jpg",
      "alt": "Box truck sidewall framing exposed inside the workshop",
      "caption": "Box truck sidewall framing in the workshop.",
      "objectPosition": "50% 50%"
    },
    "related": [
      {
        "path": "/box-truck-repair.html",
        "label": "Box truck body repair"
      },
      {
        "path": "/box-truck-roof-leak-body-repair",
        "label": "Roof and leak repair"
      },
      {
        "path": "/CommercialVehicleGraphicWraps.html",
        "label": "Commercial graphics and wraps"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/Box-Truck-Wall-Repair-Near-Me",
      "https://www.motorcitytruckcollision.com/box-truck-repair.html"
    ],
    "preservedFacts": [
      "Wall construction includes outer skin, frame, lining and insulation where present.",
      "Punctures, separation, corrosion and panel replacement are existing topics.",
      "Sealing and paint matching are part of repair scope.",
      "Unsupported CFRT and R-13 upgrade claims excluded."
    ]
  },
  {
    "id": "box-truck-roof-leak-body-repair",
    "path": "/box-truck-roof-leak-body-repair",
    "kind": "service",
    "navLabel": "Box Truck Roof Leaks",
    "eyebrow": "Roof openings and water intrusion",
    "title": "Box Truck Roof Leak and Body Repair | Motor City Truck Collision",
    "description": "Box truck roof leak and body repair in Brighton. Review damaged roof skin, joints and adjoining body areas with Motor City Truck Collision.",
    "h1": "Box Truck Roof Leak and Body Repair",
    "intro": "A leaking box truck roof may involve a torn panel, an open seam or damage where the roof meets the body. Motor City Truck Collision in Brighton assesses the opening and adjoining bodywork so the repair request addresses more than the visible drip.",
    "answer": {
      "question": "What should a box truck roof leak assessment cover?",
      "text": "It should identify where water enters and which parts of the body are affected. Roof skin, seams, front-wall joints, rear headers and interior damage may all be relevant. Describe when the leak occurs and share exterior and interior photos to help the shop discuss repair options."
    },
    "sections": [
      {
        "heading": "Trace the opening and the water damage",
        "paragraphs": [
          "Explain whether the leak followed an impact, appeared during rain or became noticeable around a particular roof joint. A stain inside the box does not necessarily sit directly below the entry point."
        ],
        "bullets": [
          "Torn or damaged roof skin",
          "Open or deteriorated seams",
          "Damage along the front wall or rear header",
          "Wet lining, wall areas or flooring"
        ]
      },
      {
        "heading": "Keep the connected body repair in view",
        "paragraphs": [
          "An opening near a corner can involve the roof and sidewall together. Damage around the rear of the box may also affect the door opening. Include these areas in the request rather than photographing only the roof surface.",
          "Repair scope depends on the condition of the panels and supporting material. Discuss whether the work involves a local repair, replacement material or additional bodywork before treating it as a sealant-only job."
        ]
      }
    ],
    "checklist": {
      "heading": "Help the shop review your roof leak",
      "items": [
        "Vehicle and cargo-body type",
        "Where and when the leak appears",
        "A wide roof view and close-ups of the damaged area",
        "Interior staining or damage beneath and around the leak",
        "Any related corner, wall or door damage"
      ]
    },
    "faqs": [
      {
        "question": "Can water enter somewhere other than the drip location?",
        "answer": "Yes. The assessment includes roof seams and adjoining body joints because water can travel before becoming visible inside the box."
      },
      {
        "question": "Can a torn roof panel be fixed with sealant alone?",
        "answer": "Sealant does not replace missing or torn panel material. The shop needs to review the opening and supporting area before discussing the repair."
      },
      {
        "question": "Should I mention soft flooring after a roof leak?",
        "answer": "Yes. Include photos and a description. Water-related floor or lining damage can change the scope of the body assessment."
      }
    ],
    "related": [
      {
        "path": "/Box-Truck-Roof-Repair-Cost",
        "label": "Roof repair quote factors"
      },
      {
        "path": "/Box-Truck-Wall-Repair-Near-Me",
        "label": "Box truck wall repair"
      },
      {
        "path": "/box-truck-repair.html",
        "label": "Box truck repair"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/box-truck-roof-leak-body-repair",
      "https://www.motorcitytruckcollision.com/Box-Truck-Roof-Repair-Cost"
    ],
    "preservedFacts": [
      "Roof leaks involve skin, seams and adjoining body joints.",
      "Water can affect lining, walls and floors.",
      "Repair scope distinguishes local work from panel replacement.",
      "No price or repair-time guarantee added."
    ]
  },
  {
    "id": "isuzu-body-repair",
    "path": "/Isuzu-Repair",
    "kind": "service",
    "navLabel": "Isuzu Body Repair",
    "eyebrow": "NPR and NQR bodywork",
    "title": "Isuzu NPR and NQR Body Repair in Brighton | Motor City Truck Collision",
    "description": "Isuzu NPR and NQR collision bodywork, cargo-body repair and paint in Brighton. Separate cab damage from box, roof and floor repairs when requesting a quote.",
    "h1": "Isuzu Body Repair for Cab-Over Work Trucks",
    "intro": "Motor City Truck Collision provides bodywork and painting for Isuzu NPR, NQR and comparable cab-over commercial trucks in Brighton. Describe the damage to the cab and cargo body separately so the request identifies the parts of the vehicle that need attention.",
    "answer": {
      "question": "Does Isuzu body repair include the cab and the cargo box?",
      "text": "Our bodywork covers collision repairs and paint, along with cargo-body and floor repairs. A damaged cab panel and a torn freight-box corner are different repair scopes. Include the model and separate photos of the cab, cargo box and any adjoining damage."
    },
    "sections": [
      {
        "heading": "Separate the truck cab from the cargo body",
        "paragraphs": [
          "The cab is part of the truck. The cargo box may have its own construction, doors, lining and flooring. Describing only an Isuzu model does not show which body components were damaged."
        ],
        "bullets": [
          "Cab panels and collision paint",
          "Cargo-box corners, walls and roof",
          "Rear doors and the surrounding opening",
          "Freight-box floor and interior lining"
        ]
      },
      {
        "heading": "Describe how the damage affects the body",
        "paragraphs": [
          "Tell the shop whether a door no longer closes evenly, water is entering the box or the floor has a damaged section. These details help explain the assessment needed beyond the visible dent.",
          "For fleet trucks, include the unit number and paint standard if available. If the request concerns engine codes or drivetrain performance, identify that separately so it can be directed to the appropriate repair service."
        ]
      }
    ],
    "checklist": {
      "heading": "Details for an Isuzu bodywork request",
      "items": [
        "Isuzu model and year",
        "Cargo-body type and any available body markings",
        "Wide and close-up photos of cab damage",
        "Separate photos of box, door, roof or floor damage",
        "Paint code or fleet colors, if available"
      ]
    },
    "faqs": [
      {
        "question": "Do you work on NPR and NQR cargo bodies?",
        "answer": "Yes. We work on NPR and NQR box-truck bodies. Include the box construction and damaged area with your model information."
      },
      {
        "question": "Where should I start for floor damage?",
        "answer": "Use the Isuzu freight-box floor repair page and include photos of the floor surface, affected edges and any visible damage beneath it."
      },
      {
        "question": "Is this an Isuzu engine repair page?",
        "answer": "This page covers bodywork and paint. Describe engine or drivetrain concerns separately when contacting the shop for routing."
      }
    ],
    "related": [
      {
        "path": "/Isuzu-Box-Truck-Repair",
        "label": "Isuzu box truck repair"
      },
      {
        "path": "/Isuzu-Freight-Box-Floor-Repair",
        "label": "Isuzu freight-box floor repair"
      },
      {
        "path": "/isuzu-box-truck-roof-repair",
        "label": "Isuzu box roof repair"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/Isuzu-Repair",
      "https://www.motorcitytruckcollision.com/Isuzu-Box-Truck-Repair"
    ],
    "preservedFacts": [
      "NPR/NQR cab-over truck bodywork and painting.",
      "Cargo-body and floor repair scope.",
      "Cab and cargo-body damage need separate description.",
      "Engine/drivetrain intent is distinct from collision bodywork."
    ]
  },
  {
    "id": "isuzu-box-truck-repair",
    "path": "/Isuzu-Box-Truck-Repair",
    "kind": "service",
    "navLabel": "Isuzu Box Truck Repair",
    "eyebrow": "Isuzu cargo bodies",
    "title": "Isuzu Box Truck Body Repair in Brighton | Motor City Truck Collision",
    "description": "Isuzu box truck body repair in Brighton for cargo-box panels, corners, doors, roofs and flooring. Share the box type and damaged areas for assessment.",
    "h1": "Isuzu Box Truck Cargo-Body Repair",
    "intro": "Motor City Truck Collision repairs Isuzu box truck cargo bodies in Brighton. This page focuses on the freight box behind the cab: its panels, corners, doors, roof and floor. Cab damage can be included in the request, but should be described separately.",
    "answer": {
      "question": "What information is needed for an Isuzu box truck repair quote?",
      "text": "Provide the Isuzu model, cargo-box type and clear photos of the damaged area. Show the whole box as well as the impact, opening or floor problem. The assessment needs to distinguish damage to the cargo body from damage to the cab or the structure supporting the box."
    },
    "sections": [
      {
        "heading": "Review the box as a connected body",
        "paragraphs": [
          "A damaged corner can affect adjoining wall and roof panels. A rear impact can involve the door opening as well as the visible skin. Include the connected areas so the request does not stop at the first damaged panel."
        ],
        "bullets": [
          "Cargo-body walls and corners",
          "Roof openings and water intrusion",
          "Rear or side doors and their surrounding structure",
          "Damaged floor or interior lining"
        ]
      },
      {
        "heading": "Describe the construction and the problem",
        "paragraphs": [
          "If available, include body-builder markings, panel material and the type of flooring. The truck model alone does not identify every component fitted to its cargo body.",
          "Explain whether the damage followed an impact, whether the box is leaking or whether a door has changed position. For a fleet unit, also include the unit number, paint standard and any insurance or purchase-order information."
        ]
      }
    ],
    "checklist": {
      "heading": "Prepare an Isuzu cargo-body request",
      "items": [
        "Truck model, year and fleet unit number",
        "Cargo-box type and body-builder markings, if available",
        "Wide photos of the box and rear opening",
        "Close-ups of damaged corners, panels, roof or floor",
        "Relevant paint or graphics details"
      ]
    },
    "faqs": [
      {
        "question": "Is cargo-box repair the same as cab repair?",
        "answer": "No. The freight box has its own panels, doors and floor. Photograph cab damage separately so both scopes can be considered without confusing the components."
      },
      {
        "question": "Can you assess more than one damaged box area?",
        "answer": "Yes. Include all affected walls, corners, doors, roof and floor areas in the request rather than submitting only the most visible damage."
      },
      {
        "question": "Which page covers a damaged Isuzu freight-box floor?",
        "answer": "The Isuzu freight-box floor repair page focuses on decking and its supporting area. Include floor photos and information about the current material."
      }
    ],
    "related": [
      {
        "path": "/Isuzu-Freight-Box-Floor-Repair",
        "label": "Isuzu freight-box floor repair"
      },
      {
        "path": "/isuzu-box-truck-roof-repair",
        "label": "Isuzu box roof repair"
      },
      {
        "path": "/Isuzu-Repair",
        "label": "Isuzu cab and body repair"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/Isuzu-Box-Truck-Repair",
      "https://www.motorcitytruckcollision.com/box-truck-repair.html",
      "https://www.motorcitytruckcollision.com/Isuzu-Repair"
    ],
    "preservedFacts": [
      "Isuzu freight-box body and floor scope.",
      "Cargo body is distinct from the cab.",
      "Connected corners, wall, roof and door damage should be described.",
      "Model and photographs begin a scope-specific quote discussion."
    ]
  },
  {
    "id": "isuzu-freight-box-floor-repair",
    "path": "/Isuzu-Freight-Box-Floor-Repair",
    "kind": "service",
    "navLabel": "Isuzu Freight-Box Floors",
    "eyebrow": "Cargo-box flooring",
    "title": "Isuzu Freight-Box Floor Repair and Replacement | Motor City Truck Collision",
    "description": "Isuzu freight-box floor repair in Brighton. Review damaged decking, supporting structure, lining and tie-downs with Motor City Truck Collision.",
    "h1": "Isuzu Freight-Box Floor Repair",
    "intro": "Motor City Truck Collision assesses and repairs damaged Isuzu freight-box flooring in Brighton. The work concerns the cargo floor and its supporting area, including damage after an impact or water intrusion. Describe the floor construction and the part of the box affected.",
    "answer": {
      "question": "Can an Isuzu freight-box floor be repaired rather than replaced?",
      "text": "The answer depends on the extent of the damage, the existing flooring and the condition beneath it. A damaged section and a floor with wider deterioration require different assessments. Photos should show the floor surface, affected edges and any visible damage to the supporting structure."
    },
    "sections": [
      {
        "heading": "Inspect the floor and what supports it",
        "paragraphs": [
          "A cargo-floor repair starts with the damaged decking, but the assessment may also need to cover framing beneath it. Explain whether the problem followed a collision, appeared after a leak or developed around a particular loading area."
        ],
        "bullets": [
          "Cracked, broken or damaged floor sections",
          "Edges and fasteners around the affected area",
          "Visible damage beneath the decking",
          "Tie-downs or lining adjoining the repair"
        ]
      },
      {
        "heading": "Match the repair discussion to the existing floor",
        "paragraphs": [
          "Identify whether the floor is wood, metal tread plate or another commercial decking system. Replacement material and repair scope depend on the existing construction and how the cargo box is used.",
          "If water has reached the floor, include the suspected roof, wall or door opening in the request. A floor repair and a leak repair address different parts of the problem."
        ]
      }
    ],
    "checklist": {
      "heading": "Details for a freight-floor assessment",
      "items": [
        "Isuzu model and cargo-box type",
        "Current floor material, if known",
        "Wide floor photos and close-ups of damaged sections",
        "Visible support, edge and fastening damage",
        "Any leak, impact or affected tie-downs"
      ]
    },
    "faqs": [
      {
        "question": "Should the structure beneath the floor be included?",
        "answer": "Yes. The floor assessment includes underlying damage. Include visible supporting areas without limiting the request to the top surface."
      },
      {
        "question": "Can tie-downs and interior lining affect the scope?",
        "answer": "Yes. Components attached to or adjoining the damaged floor may need to be considered with the flooring. Show their position and any damage."
      },
      {
        "question": "What if the floor damage came from a roof leak?",
        "answer": "Describe the water intrusion and include the roof or wall opening if known. The request should identify both the floor damage and the likely entry point."
      }
    ],
    "related": [
      {
        "path": "/Isuzu-Box-Truck-Repair",
        "label": "Isuzu cargo-body repair"
      },
      {
        "path": "/isuzu-box-truck-roof-repair",
        "label": "Isuzu roof repair"
      },
      {
        "path": "/box-truck-roof-leak-body-repair",
        "label": "Cargo-box roof leaks"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/Isuzu-Freight-Box-Floor-Repair",
      "https://www.motorcitytruckcollision.com/box-truck-repair.html"
    ],
    "preservedFacts": [
      "Damaged floor inspection includes underlying structure.",
      "Partial versus wider replacement scope.",
      "Existing wood and metal flooring construction matters.",
      "Lining, tie-downs, fasteners and water intrusion are relevant."
    ]
  },
  {
    "id": "isuzu-box-roof-repair",
    "path": "/isuzu-box-truck-roof-repair",
    "existingAliases": [
      "/33.html"
    ],
    "kind": "service",
    "navLabel": "Isuzu Box Roof Repair",
    "eyebrow": "Isuzu cargo-box roofs",
    "title": "Isuzu Box Truck Roof Repair in Brighton | Motor City Truck Collision",
    "description": "Isuzu cargo-box roof repair in Brighton for damaged panels, seams and leaks. Include adjoining wall damage and interior water intrusion in your request.",
    "h1": "Isuzu Box Truck Roof Repair",
    "intro": "Motor City Truck Collision assesses Isuzu cargo-box roof damage in Brighton. Roof repair concerns the top of the freight body and its adjoining joints, rather than the cab roof or cargo floor. Identify which roof is damaged when contacting the shop.",
    "answer": {
      "question": "What should I include for an Isuzu box roof repair assessment?",
      "text": "Include the truck model, cargo-body type and photos of the roof opening or damaged panel. Show where the roof meets the walls, plus any water staining inside the box. The assessment needs to identify the roof damage and whether adjoining body areas are affected."
    },
    "sections": [
      {
        "heading": "Identify the roof area involved",
        "paragraphs": [
          "A cargo-box roof can be damaged at a panel, seam, front corner or rear header. Describe whether the problem began after an impact or became noticeable as a leak. If the cab roof is also damaged, photograph and identify it separately."
        ],
        "bullets": [
          "Damaged roof skin or panels",
          "Open joints and roof seams",
          "Front-wall or rear-header damage",
          "Interior signs of water intrusion"
        ]
      },
      {
        "heading": "Separate roof repair from floor repair",
        "paragraphs": [
          "Water from a roof opening may damage lining, walls or flooring. Include those areas in the request, while making clear that the roof is the entry point you want assessed.",
          "Repair options depend on the opening, panel condition and adjoining material. A local seam repair and replacement roof-panel work are different scopes; the truck model alone does not establish which is needed."
        ]
      }
    ],
    "checklist": {
      "heading": "Prepare your Isuzu roof repair request",
      "items": [
        "Isuzu model and cargo-body details",
        "Whether the concern is the cab roof or cargo-box roof",
        "A wide roof view and close-ups of the opening",
        "Photos of adjoining corners, walls and joints",
        "Interior staining or related floor damage"
      ]
    },
    "faqs": [
      {
        "question": "Is this page about the cab roof or the freight-box roof?",
        "answer": "It focuses on the cargo-box roof. Cab damage belongs in the broader Isuzu bodywork request and should be identified separately."
      },
      {
        "question": "Does a roof leak always require a new roof?",
        "answer": "The opening and surrounding material determine the assessment. A seam problem, torn panel and wider body damage should not be treated as the same repair."
      },
      {
        "question": "Which page should I use for a damaged cargo floor?",
        "answer": "Use the Isuzu freight-box floor repair page. If a leak caused the damage, include the roof and interior photos with the floor request."
      }
    ],
    "related": [
      {
        "path": "/Isuzu-Freight-Box-Floor-Repair",
        "label": "Isuzu freight-box floor repair"
      },
      {
        "path": "/Isuzu-Box-Truck-Repair",
        "label": "Isuzu cargo-body repair"
      },
      {
        "path": "/Box-Truck-Roof-Repair-Cost",
        "label": "Roof repair quote factors"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/33.html",
      "https://www.motorcitytruckcollision.com/box-truck-roof-leak-body-repair",
      "https://www.motorcitytruckcollision.com/Box-Truck-Roof-Repair-Cost"
    ],
    "preservedFacts": [
      "Existing /33.html title and buyer intent are Isuzu roof repair.",
      "Corrects old page opening that mistakenly repeats floor instructions.",
      "Cargo roof, cab roof and floor are separate components.",
      "Adjoining joints and water intrusion affect repair assessment."
    ]
  },
  {
    "id": "ford-commercial-truck-body-shop",
    "path": "/Ford-Body-Shop-Collision-Repair-and-Paint-Shop",
    "kind": "service",
    "navLabel": "Ford Truck Bodywork",
    "eyebrow": "Ford work-truck bodies",
    "title": "Ford Truck Body Shop and Commercial Painting | Motor City Truck Collision",
    "description": "Ford truck collision bodywork, rust repair and painting in Brighton. Request assessment of cab, pickup-bed or commercial-body damage at Motor City Truck Collision.",
    "h1": "Ford Truck Bodywork, Collision Repair and Painting",
    "intro": "Motor City Truck Collision provides Ford truck bodywork and painting in Brighton. We review damage to the cab, pickup bed or fitted commercial body, with dedicated pages for F-250, F-550 and F-600 repair requests. Include the model, year and body configuration.",
    "answer": {
      "question": "What does a Ford truck bodywork request need to cover?",
      "text": "Describe the damaged panels and any fitted body or upfit affected by the impact. Cab, pickup-bed and commercial-body repairs involve different components. Include photos of each damaged area, plus paint or fleet-color information, so the shop can discuss bodywork and refinishing together."
    },
    "sections": [
      {
        "heading": "Start with the body configuration",
        "paragraphs": [
          "Two Ford trucks with the same model badge may carry different work bodies. A pickup bed, service body and dump body create different repair questions. Identify the fitted equipment rather than relying on the model alone."
        ],
        "bullets": [
          "Cab doors, hood, fenders and related panels",
          "Pickup-bed and rear body damage",
          "Compartments and panels on service bodies",
          "Collision damage to fitted work bodies"
        ]
      },
      {
        "heading": "Include rust and paint concerns",
        "paragraphs": [
          "A request can involve collision damage, corrosion or painting without a recent accident. Describe which areas need attention and whether matching existing fleet colors is part of the job.",
          "If an impact affected more than the visible skin, include the adjoining mounting and structural areas in your photos. The assessment should cover the connected damage before the paint scope is discussed."
        ]
      }
    ],
    "checklist": {
      "heading": "Information for a Ford bodywork request",
      "items": [
        "Ford model, year and body configuration",
        "Photos of damaged cab panels and rear body areas",
        "Details of any service, dump or other fitted body",
        "Visible corrosion or adjoining structural damage",
        "Paint code, fleet colors or graphics requirements"
      ]
    },
    "faqs": [
      {
        "question": "Can I request painting without collision repair?",
        "answer": "Yes. We offer painting for Ford commercial trucks. Describe the areas to be refinished, the current finish and the colors required."
      },
      {
        "question": "Which truck and fitted-body details should I provide?",
        "answer": "Include the Ford model and year, body manufacturer if known, and the panels or compartments that need attention. Identify any aftermarket equipment or body modifications."
      },
      {
        "question": "Should I describe the cab and work body separately?",
        "answer": "Yes. Separate descriptions help distinguish truck panels from the commercial body or equipment fitted behind the cab."
      }
    ],
    "related": [
      {
        "path": "/Ford-F-250-Body-Shop-Collision-Repair-and-Paint-Shop",
        "label": "Ford F-250 bodywork"
      },
      {
        "path": "/Ford-F-550-Body-Shop",
        "label": "Ford F-550 bodywork"
      },
      {
        "path": "/Ford-F-600-Body-Shop-Collision-Repair-and-Paint-Shop-Service-Center",
        "label": "Ford F-600 bodywork"
      },
      {
        "path": "/Commercial-Truck-Paint-Shop",
        "label": "Commercial truck painting"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/Ford-Body-Shop-Collision-Repair-and-Paint-Shop"
    ],
    "preservedFacts": [
      "Ford collision body repair and painting.",
      "Cab, pickup-bed and fitted commercial-body distinctions.",
      "Service/dump work-body repair intent.",
      "No engine specifications, ratings, dealer or manufacturer-certification claims."
    ]
  },
  {
    "id": "ford-f250-body-repair",
    "path": "/Ford-F-250-Body-Shop-Collision-Repair-and-Paint-Shop",
    "kind": "service",
    "navLabel": "Ford F-250 Bodywork",
    "eyebrow": "Super Duty pickup bodywork",
    "title": "Ford F-250 Collision Bodywork and Painting | Motor City Truck Collision",
    "description": "Ford F-250 body and paint repair in Brighton for damaged cab panels, pickup beds, bumpers and work-body components. Request a damage assessment.",
    "h1": "Ford F-250 Bodywork and Collision Painting",
    "intro": "Motor City Truck Collision repairs and refinishes Ford F-250 bodies in Brighton. The request may concern damaged cab panels, the pickup bed, front-end body components or a fitted work body. Include the truck's year and configuration so the damage can be assessed in context.",
    "answer": {
      "question": "Which F-250 damage should be included in a bodywork request?",
      "text": "Show damaged doors, fenders, hood, bed sides, bumpers and adjoining body areas. If the truck carries a service body or other fitted equipment, identify that separately. Include visible structural concerns after an impact rather than requesting paint on the damaged panel alone."
    },
    "sections": [
      {
        "heading": "Review cab and bed damage separately",
        "paragraphs": [
          "Damage to a cab door and damage to a pickup-bed side involve different panels and adjoining components. A side impact may affect more than the outer skin, while front-end damage can involve several body parts together."
        ],
        "bullets": [
          "Cab doors, fenders and hood",
          "Pickup-bed sides and rear body panels",
          "Bumpers, grille and surrounding body components",
          "Fitted work-body panels or compartments"
        ]
      },
      {
        "heading": "Plan bodywork before refinishing",
        "paragraphs": [
          "Describe dents, torn panels, corrosion and any areas that no longer line up as before. These observations help the shop discuss repair or replacement scope before reviewing the finish.",
          "Painting-only requests are also welcome. Provide the current color, any fleet paint code and the areas to be refinished. Body construction and fitted equipment can vary, so include the year and photos rather than assuming every F-250 is the same."
        ]
      }
    ],
    "checklist": {
      "heading": "Prepare an F-250 repair request",
      "items": [
        "Truck year and cab/bed configuration",
        "Wide photos of the damaged side or end",
        "Close-ups of panels, bumpers and adjoining joints",
        "Any fitted work body or equipment involved",
        "Rust, paint color and graphics details"
      ]
    },
    "faqs": [
      {
        "question": "Can damaged F-250 bed sides be assessed?",
        "answer": "Yes. We assess damaged pickup-bed panels. Show the full damaged side and any adjoining corner or rear body damage."
      },
      {
        "question": "What if the impact also affected alignment of body parts?",
        "answer": "Mention what changed and include photos of the adjoining areas. The request should identify possible connected damage without relying on a remote diagnosis."
      },
      {
        "question": "Can I include rust repair and paint in one request?",
        "answer": "Yes. Describe the corrosion and the finish you want reviewed so the shop can discuss the body preparation and refinishing scope together."
      }
    ],
    "related": [
      {
        "path": "/Ford-Body-Shop-Collision-Repair-and-Paint-Shop",
        "label": "Ford truck bodywork"
      },
      {
        "path": "/Service-Body-Repair",
        "label": "Service-body repairs"
      },
      {
        "path": "/Commercial-Truck-Paint-Shop",
        "label": "Commercial painting"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/Ford-F-250-Body-Shop-Collision-Repair-and-Paint-Shop"
    ],
    "preservedFacts": [
      "F-250 model-specific body, panel, bed, bumper and grille repair intent.",
      "Frame/structural assessment may accompany collision damage.",
      "Rust repair and refinishing.",
      "No model-year specifications or manufacturer affiliation added."
    ]
  },
  {
    "id": "ford-f550-body-repair",
    "path": "/Ford-F-550-Body-Shop",
    "kind": "service",
    "navLabel": "Ford F-550 Bodywork",
    "eyebrow": "Chassis-cab and work-body repairs",
    "title": "Ford F-550 Bodywork and Commercial Painting | Motor City Truck Collision",
    "description": "Ford F-550 collision bodywork and painting in Brighton. Describe cab damage and fitted service, dump or other work-body damage for assessment.",
    "h1": "Ford F-550 Cab and Work-Body Repairs",
    "intro": "Motor City Truck Collision provides Ford F-550 bodywork and painting in Brighton. An F-550 can carry a service body, dump body or other work equipment, so a useful repair request identifies both the cab and the fitted body affected by the damage.",
    "answer": {
      "question": "What should an F-550 body repair assessment include?",
      "text": "Include damaged cab panels, the fitted work body and the areas joining that body to the truck. A cab impact, bent compartment door and damaged dump-body panel create different repair scopes. Photos and configuration details help the shop review the connected bodywork before discussing paint."
    },
    "sections": [
      {
        "heading": "Identify the work body fitted to your truck",
        "paragraphs": [
          "The model badge does not describe every body or upfit on an F-550. Explain whether the truck carries a utility/service body, dump body, towing equipment or another commercial configuration."
        ],
        "bullets": [
          "Cab panels and front-end body damage",
          "Compartments and doors on utility bodies",
          "Damaged dump-body or other work-body panels",
          "Adjoining mounting and structural areas"
        ]
      },
      {
        "heading": "Keep body alignment and refinishing in the same discussion",
        "paragraphs": [
          "If a compartment door no longer closes evenly or body panels have shifted after an impact, describe those changes and show the surrounding areas. Include damage beyond the most visible dent.",
          "Painting may involve a repaired panel, the cab or a wider work-body finish. Provide fleet colors or paint codes if available, and identify graphics that are affected. The body assessment establishes what needs attention before the refinishing scope is agreed."
        ]
      }
    ],
    "checklist": {
      "heading": "Prepare your F-550 request",
      "items": [
        "Truck year and fitted body configuration",
        "Wide photos of the cab and work body",
        "Close-ups of damaged doors, compartments or panels",
        "Any visible adjoining structural or mounting damage",
        "Paint codes, fleet colors and affected graphics"
      ]
    },
    "faqs": [
      {
        "question": "Can I request service-body repairs on an F-550?",
        "answer": "Yes. Service-body repair includes compartments, doors and body damage. Identify the body manufacturer or model if available, and show the affected areas separately from the cab."
      },
      {
        "question": "What if the cab and rear body were both hit?",
        "answer": "Include separate wide and close-up photos of each. The request should make clear which truck panels and fitted-body components are damaged."
      },
      {
        "question": "Does the truck year matter for bodywork?",
        "answer": "Yes. Provide the year and configuration so the shop can discuss the correct body components without assuming every F-550 uses the same construction."
      }
    ],
    "related": [
      {
        "path": "/Service-Body-Repair",
        "label": "Service-body repair"
      },
      {
        "path": "/Knapheide-Service-Body-Restoration",
        "label": "Knapheide body restoration"
      },
      {
        "path": "/Ford-Body-Shop-Collision-Repair-and-Paint-Shop",
        "label": "Ford truck bodywork"
      },
      {
        "path": "/Commercial-Truck-Paint-Shop",
        "label": "Commercial painting"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/Ford-F-550-Body-Shop",
      "https://www.motorcitytruckcollision.com/Service-Body-Repair"
    ],
    "preservedFacts": [
      "F-550 cab and commercial upfit/body repair intent.",
      "Utility/service, dump and towing configurations named in source.",
      "Compartment, panel, structural and paint concerns.",
      "No model-year engine/GVWR/material specifications added."
    ]
  },
  {
    "id": "ford-f600-body-repair",
    "path": "/Ford-F-600-Body-Shop-Collision-Repair-and-Paint-Shop-Service-Center",
    "kind": "service",
    "navLabel": "Ford F-600 Bodywork",
    "eyebrow": "Commercial chassis-cab bodies",
    "title": "Ford F-600 Collision Bodywork and Painting | Motor City Truck Collision",
    "description": "Ford F-600 commercial bodywork and paint in Brighton. Request assessment of cab, fitted work-body and adjoining collision damage at Motor City Truck Collision.",
    "h1": "Ford F-600 Commercial Bodywork and Painting",
    "intro": "Motor City Truck Collision assesses Ford F-600 collision bodywork and painting in Brighton. Tell us how the truck is configured, including the cab and the service, dump or other commercial body fitted behind it. That information defines the body-repair discussion.",
    "answer": {
      "question": "How do I describe damage to an F-600 work truck?",
      "text": "Identify the damaged truck panels and the fitted commercial body separately. Include wide views of the vehicle, close-ups of the impact and any adjoining body or mounting damage. The model alone does not show the work-body construction, paint requirements or full repair scope."
    },
    "sections": [
      {
        "heading": "Separate cab repairs from work-body repairs",
        "paragraphs": [
          "An F-600 repair request can concern the cab, a fitted utility body, a dump body or another commercial configuration. Describe which areas were affected rather than treating the whole vehicle as one panel."
        ],
        "bullets": [
          "Cab doors, hood and surrounding body panels",
          "Work-body sides, doors or compartments",
          "Adjoining body joints and mounting areas",
          "Paint and graphics on damaged surfaces"
        ]
      },
      {
        "heading": "Include the connected damage and finish requirements",
        "paragraphs": [
          "A panel impact may also affect the area supporting or adjoining it. Show visible changes around body joints, openings and mounting points, and tell the shop if doors or compartments no longer line up as before.",
          "For refinishing, provide the current color and any fleet paint standard. A painting-only request does not need collision damage; describe the areas to be refinished and the intended colors so the finish can be discussed separately."
        ]
      }
    ],
    "checklist": {
      "heading": "Information for an F-600 bodywork request",
      "items": [
        "Ford model year and body configuration",
        "Body manufacturer or available identification markings",
        "Wide vehicle views and close-up damage photos",
        "Any affected doors, joints or mounting areas",
        "Fleet colors, paint codes and graphics requirements"
      ]
    },
    "faqs": [
      {
        "question": "Can you assess a fitted service or dump body?",
        "answer": "Service and dump-body configurations are part of our F-600 bodywork scope. Identify the body and provide photos so the shop can discuss the damaged components and repair scope."
      },
      {
        "question": "Should I include damage near a body mounting point?",
        "answer": "Yes. Show the damaged panel and the adjoining area. This helps the assessment address connected damage without relying on a photo-based diagnosis alone."
      },
      {
        "question": "Do I need engine or payload information to request paint?",
        "answer": "Begin with the year, body configuration and surfaces to be refinished. Engine specifications do not describe the condition or paint scope of those body panels."
      }
    ],
    "related": [
      {
        "path": "/Ford-Body-Shop-Collision-Repair-and-Paint-Shop",
        "label": "Ford truck bodywork"
      },
      {
        "path": "/Service-Body-Repair",
        "label": "Service-body repairs"
      },
      {
        "path": "/Fleet-Truck-Body-Repair",
        "label": "Fleet body repair"
      },
      {
        "path": "/Commercial-Truck-Paint-Shop",
        "label": "Commercial painting"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/Ford-F-600-Body-Shop-Collision-Repair-and-Paint-Shop-Service-Center"
    ],
    "preservedFacts": [
      "F-600 commercial collision and paint intent.",
      "Cab versus service/dump/other fitted body distinction.",
      "Panel, structural and finish concerns.",
      "Engine, transmission, GVWR and material claims intentionally omitted."
    ]
  },
  {
    "id": "service-body-repair",
    "path": "/Service-Body-Repair",
    "kind": "service",
    "navLabel": "Service-Body Repair",
    "eyebrow": "Utility and contractor truck bodies",
    "title": "Service-Body Repair in Brighton, MI | Motor City Truck Collision",
    "description": "Service-body repairs for utility and contractor trucks in Brighton. Review damaged compartments, doors, rust-through and body alignment with the shop.",
    "h1": "Service-Body Repair for Utility and Contractor Trucks",
    "intro": "Motor City Truck Collision repairs utility and contractor service bodies in Brighton. The work includes damaged compartments, doors, rust-through and collision bodywork. A service body is part of the truck's working equipment, so describe how the damage affects its storage and openings.",
    "answer": {
      "question": "Can a damaged or rusted service-body door be repaired?",
      "text": "Repair options depend on the door and the structure around it. Surface corrosion differs from rust-through in the door frame or hinge pillar. Send photos of the outer panel, hinges and surrounding compartment so the assessment can distinguish local repair from replacement work."
    },
    "sections": [
      {
        "heading": "Assess the compartment, not only its outer skin",
        "paragraphs": [
          "A door that looks dented may also have damage around its hinges, latch or compartment opening. After a side impact, include adjoining compartments and show whether the doors still line up as before."
        ],
        "bullets": [
          "Compartment and door panels",
          "Hinge pillars and surrounding structure",
          "Collision damage across adjoining compartments",
          "Corrosion and rust-through"
        ]
      },
      {
        "heading": "Include the body's relationship to the truck",
        "paragraphs": [
          "The service-body assessment also considers whether the body has shifted relative to the chassis. Show visible damage around mounting areas and tell the shop what changed after the impact.",
          "If paint or fleet graphics are part of the request, include those details with the body photos. The discussion should cover the repair scope before refinishing, rather than focusing only on improving the outer appearance."
        ]
      }
    ],
    "checklist": {
      "heading": "Details for a service-body assessment",
      "items": [
        "Truck model and year",
        "Service-body manufacturer or model, if known",
        "Wide views of the body and affected compartments",
        "Close-ups of doors, hinges, latch areas and corrosion",
        "Paint colors or graphics affected by the damage"
      ]
    },
    "faqs": [
      {
        "question": "Can you assess a body after a side impact?",
        "answer": "Yes. Include the damaged side and adjoining compartments. The request should show panel damage, opening alignment and any visible movement of the body."
      },
      {
        "question": "Why do you need a hinge-pillar photo?",
        "answer": "The structure supporting the door matters to the repair. A photo of the outer skin alone does not show corrosion or damage around the hinges."
      },
      {
        "question": "Which page covers Knapheide bodies?",
        "answer": "The Knapheide service-body restoration page focuses on that body family. Include the body model or identification markings if available."
      }
    ],
    "related": [
      {
        "path": "/Knapheide-Service-Body-Restoration",
        "label": "Knapheide body restoration"
      },
      {
        "path": "/Fleet-Truck-Body-Repair",
        "label": "Fleet body repair"
      },
      {
        "path": "/Commercial-Truck-Paint-Shop",
        "label": "Commercial truck painting"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/Service-Body-Repair"
    ],
    "preservedFacts": [
      "Utility/contractor service-body compartments, doors and collision repair.",
      "Surface corrosion differs from rust-through.",
      "Hinge-pillar and compartment alignment assessment.",
      "Body position relative to chassis and refinishing scope."
    ]
  },
  {
    "id": "knapheide-service-body-restoration",
    "path": "/Knapheide-Service-Body-Restoration",
    "kind": "service",
    "navLabel": "Knapheide Body Restoration",
    "eyebrow": "Knapheide work-truck bodies",
    "title": "Knapheide Service-Body Repair and Restoration | Motor City Truck Collision",
    "description": "Knapheide service-body repair and restoration in Brighton. Discuss damaged compartments, doors, corrosion and refinishing at Motor City Truck Collision.",
    "h1": "Knapheide Service-Body Repair and Restoration",
    "intro": "Motor City Truck Collision assesses Knapheide service-body repairs and restoration in Brighton. Requests can involve collision damage, worn compartments, doors, corrosion or refinishing. Identify the body model and construction so the discussion concerns the body fitted to your truck.",
    "answer": {
      "question": "What should a Knapheide restoration request include?",
      "text": "Show the whole service body and the specific compartments, doors or panels needing attention. Include corrosion around hinges and openings, along with any collision damage. State whether the request is for selected repairs, wider restoration or painting, and provide body identification markings if available."
    },
    "sections": [
      {
        "heading": "Describe the body and its affected components",
        "paragraphs": [
          "Knapheide bodies can have different configurations and construction. Include whether your body is steel or aluminum if known, plus the body model or identification plate. Photos help show the arrangement of compartments and doors."
        ],
        "bullets": [
          "Damaged body and compartment panels",
          "Doors, hinge areas and latch openings",
          "Visible corrosion or rust-through",
          "Adjoining storage components affected by the damage"
        ]
      },
      {
        "heading": "Define restoration around the condition of the body",
        "paragraphs": [
          "Restoration can mean attention to selected damaged areas or work across more of the body. Describe the concerns rather than assuming the whole body needs replacement or that refinishing alone will address them.",
          "If shelving, locks or other storage features were affected, include their condition in the request. Discuss paint colors and graphics once the damaged body areas and desired scope are clear."
        ]
      }
    ],
    "checklist": {
      "heading": "Prepare a Knapheide body request",
      "items": [
        "Truck model and Knapheide body identification",
        "Steel or aluminum construction, if known",
        "Wide photos of the service body",
        "Close-ups of compartments, hinges and corrosion",
        "Selected repair, wider restoration or painting goals"
      ]
    },
    "faqs": [
      {
        "question": "What if I do not know the body model?",
        "answer": "Include photos of identification plates or markings if available, along with clear views of the full body and its compartments."
      },
      {
        "question": "Does corrosion mean the whole body must be replaced?",
        "answer": "The visible condition alone does not establish the full scope. Show the affected panels and surrounding structure so repair and replacement options can be discussed."
      },
      {
        "question": "Can I request paint as part of restoration?",
        "answer": "Yes. Refinishing is part of the service-body restoration discussion. Identify the current finish, desired colors and any graphics that need attention."
      }
    ],
    "related": [
      {
        "path": "/Service-Body-Repair",
        "label": "Utility and service-body repairs"
      },
      {
        "path": "/Fleet-Truck-Body-Repair",
        "label": "Fleet bodywork"
      },
      {
        "path": "/Commercial-Truck-Paint-Shop",
        "label": "Commercial refinishing"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/Knapheide-Service-Body-Restoration",
      "https://www.motorcitytruckcollision.com/Service-Body-Repair"
    ],
    "preservedFacts": [
      "Knapheide-specific service-body restoration buyer intent.",
      "Steel/aluminum body construction and compartments/doors.",
      "Corrosion, repair scope and refinishing.",
      "Placeholder, manufacturer-authorization and unverified upgrade promises excluded."
    ]
  },
  {
    "id": "liftgate-body-interface-repair",
    "path": "/Lift-Gate-Repair",
    "kind": "service",
    "navLabel": "Liftgate Body Repairs",
    "eyebrow": "Rear body and liftgate interfaces",
    "title": "Commercial Truck Liftgate Body Repair | Motor City Truck Collision",
    "description": "Liftgate-related truck body repair in Brighton for damaged pockets, rear sills, frames and door interfaces. Describe dock-hit damage to the shop.",
    "h1": "Liftgate Body Repairs After Rear Impacts",
    "intro": "Motor City Truck Collision repairs body damage around liftgates on box trucks and commercial straight trucks in Brighton. This service concerns the liftgate pocket, rear sill, rear frame and adjoining door interface. Hydraulic or mechanical lift operation is a separate repair question.",
    "answer": {
      "question": "Can liftgate-pocket damage be repaired after a dock hit?",
      "text": "The repair assessment depends on the pocket, rear sill and surrounding structure. A folded pocket and a distorted rear frame are different scopes. Send a straight-on rear photo and a side view so the shop can review the body damage and adjoining door opening."
    },
    "sections": [
      {
        "heading": "Show the rear opening as well as the liftgate",
        "paragraphs": [
          "An impact around the lift can affect more than the most visible sheet metal. Include the rear sill, pocket and door opening, particularly if the door no longer closes or aligns as before."
        ],
        "bullets": [
          "Liftgate pocket and surrounding panels",
          "Rear sill and rear-frame damage",
          "Door interface and opening alignment",
          "Related dock-hit body damage"
        ]
      },
      {
        "heading": "Separate body damage from lift operation",
        "paragraphs": [
          "Describe physical damage to the truck body separately from problems with the lift mechanism. This helps the shop route the request and discuss the bodywork without assuming it includes a hydraulic rebuild.",
          "If the roll-up door or rear body was damaged in the same incident, include it with the request. Connected damage can then be assessed as part of the overall rear-body scope."
        ]
      }
    ],
    "checklist": {
      "heading": "Details for a liftgate bodywork request",
      "items": [
        "Box truck or commercial straight-truck type",
        "A straight-on view of the rear opening",
        "A side view of the pocket, sill and liftgate area",
        "Close-ups of damaged body panels or joints",
        "Separate description of any lift-operation problem"
      ]
    },
    "faqs": [
      {
        "question": "Does this service include hydraulic liftgate rebuilding?",
        "answer": "This page covers the truck body around the liftgate. Identify hydraulic or mechanical concerns separately so the shop can direct them to the appropriate repair service."
      },
      {
        "question": "Should I include a damaged roll-up door?",
        "answer": "Yes. Door tracks, the rear opening and nearby bodywork can be affected by the same impact. Include photos of those areas with the liftgate-pocket damage."
      },
      {
        "question": "Why are rear and side photos useful?",
        "answer": "They show different parts of the pocket, sill and rear structure. One close-up may not show how the damage relates to the surrounding body."
      }
    ],
    "related": [
      {
        "path": "/Box-Truck-Roll-Up-Door-Repair-Near-Me",
        "label": "Box truck roll-up doors"
      },
      {
        "path": "/box-truck-repair.html",
        "label": "Box truck body repair"
      },
      {
        "path": "/Fleet-Truck-Body-Repair",
        "label": "Fleet body repairs"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/Lift-Gate-Repair"
    ],
    "preservedFacts": [
      "Truck-body collision scope around liftgate pockets, rear frames/sills and doors.",
      "Rear and side photographs requested.",
      "Body work is distinct from hydraulic or mechanical rebuilds.",
      "Related roll-up-door and rear body damage can be assessed together."
    ]
  }
]
